module.exports = __webpack_public_path__ + "img/body-2.91d6ab1f.jpg";